import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiSlice } from '../services/apiSlice';
import { iamApiSlice } from '../services/iamApiSlice';
import { creditApiSlice } from '../services/creditApiSlice';
import { orderkaroApiSlice } from '../services/orderkaroApiSlice';
import { paymentApi } from '../services/paymentApi';
import orgReducer from './orgSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [iamApiSlice.reducerPath]: iamApiSlice.reducer,
    [creditApiSlice.reducerPath]: creditApiSlice.reducer,
    [orderkaroApiSlice.reducerPath]: orderkaroApiSlice.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    org: orgReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      iamApiSlice.middleware,
      creditApiSlice.middleware,
      orderkaroApiSlice.middleware,
      paymentApi.middleware
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
